import React, { memo } from 'react';

import { Row, Col, Button } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { Field, useFormikContext } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { CustomerTypes, ECustomerSearchTypes, initialFilterValues } from 'v2/interfaces/rating';
import type { IFilter } from 'v2/interfaces/rating';

const Fields = memo(() => {
  const loading = false;
  const { resetForm, dirty, isSubmitting, isValid, values, setFieldValue } = useFormikContext<IFilter>();

  function onResetForm() {
    resetForm({ values: initialFilterValues });
  }

  const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setFieldValue('customer', '');
    setFieldValue('customer_type', v);
  };

  return (
    <Row gutter={[16, 16]} align='top' justify='space-between'>
      <Col md={6} xs={24}>
        <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
      </Col>

      <Col md={12} xs={24}>
        <Row gutter={4}>
          <Col span={8}>
            <Field
              id='customer_type'
              name='customer_type'
              label='Cliente'
              fullWidth
              options={CustomerTypes}
              component={SelectFormField}
              onChange={onChangeCustomerType}
            />
          </Col>
          <Col span={16}>
            <Field
              id='customer'
              name='customer'
              component={TextFormField}
              fullWidth
              label={values.customer_type === ECustomerSearchTypes.NAME ? 'Nome' : 'E-mail'}
              placeholder={values.customer_type === ECustomerSearchTypes.NAME ? 'Insira o nome' : 'Insira o e-mail'}
            />
          </Col>
        </Row>
      </Col>

      <Col xs={24} md={6}>
        <div className='flex w-full flex-row gap-2 md:pt-6'>
          <Button
            id='clean-filter-button'
            disabled={!dirty || isSubmitting || loading}
            onClick={() => onResetForm()}
            block
          >
            Limpar
          </Button>
          <Button
            id='filter-button'
            loading={isSubmitting || loading}
            block
            disabled={!isValid}
            icon={<Icon.Funnel  />}
            htmlType='submit'
            type='primary'
          >
            Filtrar
          </Button>
        </div>
      </Col>
    </Row>
  );
});

export default Fields;
